module.exports = __webpack_public_path__ + "img/3.ff4aa7cc.png";